const ItemTypes = {
  PLAYER: 'Player'
}

export default ItemTypes
